var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex flex-column align-items-center" }, [
    _c("video", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.capturedImageDataUri,
          expression: "!capturedImageDataUri"
        }
      ],
      ref: "videoElement",
      staticClass: "camera-preview",
      staticStyle: { "max-width": "100%" },
      attrs: { autoplay: "", playsinline: "", muted: "" },
      domProps: { muted: true }
    }),
    _vm._v(" "),
    _vm.capturedImageDataUri
      ? _c("img", {
          staticClass: "image-preview",
          staticStyle: { "max-width": "100%" },
          attrs: { src: _vm.capturedImageDataUri, alt: "captured image" }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mt-3" }, [
      !_vm.capturedImageDataUri
        ? _c(
            "button",
            { staticClass: "btn btn-primary", on: { click: _vm.takePhoto } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("common.camera.takePhoto")) +
                  "\n    "
              )
            ]
          )
        : _c(
            "button",
            { staticClass: "btn btn-primary", on: { click: _vm.clearImage } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("common.camera.retakePhoto")) +
                  "\n    "
              )
            ]
          ),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        staticClass: "d-none",
        attrs: { type: "file", accept: "image/*" },
        on: { change: _vm.handleFileSelect }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-info",
          on: {
            click: function($event) {
              return _vm.$refs.fileInput.click()
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("common.camera.selectPhoto")) + "\n    "
          )
        ]
      )
    ]),
    _vm._v(" "),
    _vm.errorMessage
      ? _c("div", { staticClass: "alert alert-danger mt-3" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }